import {useTranslation} from "react-i18next";
import {Alert, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {StyledTableCell} from "@/features/InControlPanel/ReferenceBooks/ui/StyledTableCell";
import {CircularLoading} from "@/components/Loading/CircularLoading/CircularLoading";
import {
    useGetFileMeaningsQuery
} from "@/api/ReferenceBooks/Lists/LaboratoryClarifications/FileMeanings/List/FileMeaningsListApiSlice";
import {useMemo} from "react";
import FileMeaningsListUnit
    from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/FileMeaningsListUnit";
import EditFileExtensionsDialog
    from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/EditFileExtensionsDialog";
import {useSelector} from "react-redux";
import {
    FileMeaningsSelectors
} from "@/features/InControlPanel/ReferenceBooks/LaboratoryClarifications/FileMeanings/Slice/FileMeaningsSlice";
import {WithPermission} from "@/components/Permissions/WithPermission";

function FileMeaningTable() {
    const {t} = useTranslation();

    const {data, isFetching, isSuccess} = useGetFileMeaningsQuery();
    const editFileExtensionsModalVisible = useSelector(FileMeaningsSelectors.editFileExtensionsModalVisible)

    const fileMeaningsList = useMemo(() => (data?.data ?? []), [data?.data])

    return (
      <>
          <TableContainer sx={{mt: 1, mb: 1}} component={Paper}>
              <Table sx={{minWidth: 650}}>
                  <TableHead>
                      <TableRow>
                          <StyledTableCell>ID</StyledTableCell>
                          <StyledTableCell>{t("Title")}</StyledTableCell>
                          <StyledTableCell>{t("Alias")}</StyledTableCell>
                          <StyledTableCell>{t("Active")}</StyledTableCell>

                          <WithPermission permission="file-meanings.edit">
                              <StyledTableCell>{t("Edit")}</StyledTableCell>
                          </WithPermission>

                          <WithPermission permission="file-meanings.delete">
                              <StyledTableCell>{t("Delete")}</StyledTableCell>
                          </WithPermission>
                      </TableRow>
                  </TableHead>

                  <TableBody>
                      {isSuccess && fileMeaningsList.length > 0 && (
                        <>
                            {fileMeaningsList.map(unit => <FileMeaningsListUnit
                                key={unit.id}
                                fileMeanings={unit}
                              />
                            )}
                        </>
                      )}

                      {isFetching && (
                        <TableRow>
                            <TableCell colSpan={12}>
                                <CircularLoading/>
                            </TableCell>
                        </TableRow>
                      )}

                      {isSuccess && fileMeaningsList.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={12}>
                                <Alert severity="info">{t("No data")}</Alert>
                            </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
              </Table>
          </TableContainer>

          {editFileExtensionsModalVisible && (
            <EditFileExtensionsDialog/>
          )}
      </>
    );
}

export default FileMeaningTable;
